import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const PlaylistsCtx = createContext(null);

export function PlaylistsProvider({ children }) {
  const [playlists, setPlaylists] = useState([]);

  const refresh = useCallback(() => api.get("/playlists").then((r) => setPlaylists(r.data)).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);

  const create = useCallback(async (name, track_ids = [], extra = {}) => {
    const { data } = await api.post("/playlists", { name, track_ids, ...extra });
    refresh();
    return data;
  }, [refresh]);

  const addTracks = useCallback(async (pid, track_ids) => {
    try {
      await api.post(`/playlists/${pid}/tracks`, { track_ids });
      const p = playlists.find((x) => x.id === pid);
      toast.success(`Added ${track_ids.length} track${track_ids.length > 1 ? "s" : ""} to ${p?.name || "playlist"}`);
      refresh();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, [playlists, refresh]);

  return <PlaylistsCtx.Provider value={{ playlists, refresh, create, addTracks }}>{children}</PlaylistsCtx.Provider>;
}

export const usePlaylists = () => useContext(PlaylistsCtx);
